export default __webpack_public_path__ + "static/media/github.5fd9553f.svg";